import { render, staticRenderFns } from "./djyl.vue?vue&type=template&id=2ee5ff42&scoped=true"
import script from "./djyl.vue?vue&type=script&lang=js"
export * from "./djyl.vue?vue&type=script&lang=js"
import style0 from "./djyl.vue?vue&type=style&index=0&id=2ee5ff42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee5ff42",
  null
  
)

export default component.exports